import React from 'react';
import { connect } from 'react-redux';
import Items from './components/items/Items';
import OrderPanel from '../common/OrderPanel/OrderPanel';
import AddItemPopup from './components/items/AddItemPopup';
import OutOfStockItems from '../inventory/OutOfStockItems';
import {
  locationDetails,
  modeOfOrder,
  hideOrderTypePopup,
  addItemToBag,
  addItemToBagCache,
  removeItemFromBag,
  goToCheckout,
  deliveryDetails,
  orderDate,
  orderTime,
  resetDashboard,
  locationChanged,
  setRoute,
  unsetOrderTypePopupOnAddToCart,
  updateTipPrice,
  setPaymentModeDashboard,
  checkCartItemsAvailable,
} from './actions';
import { openSignInPopUp } from '../../redux/actions/authenticationActions';
import { dashboardData, isDataNameFilterForDining } from './reducer';
import '../../public/css/Dashboard.css';
import { ToastContainer, ToastMessage } from '../../lib';
import { injectIntl, intlShape } from 'react-intl';
import axios from 'axios';
import { ADD_TO_CART, CHECK_CART_ITEMS } from '../../util/urls';
import { checkoutData } from '../checkout/reducer';
import {
  GetCartItems,
  parsePrice,
  GetOrderType,
  createModifierPath,
} from '../../lib/helper.js';
import { loading } from '../menu/actions';
import { loadMenuItems } from '../../actions/MenuItemsActions';
import { get, map, find } from 'lodash';
import { itemExist } from '../../api/api';
import alertify from 'alertifyjs';
import { initializePizzaCreatorModifiers } from './components/items/components/PizzaCreatorModifiers/utils';
import defaultMsg from '../../translations/lang/en-US.json';

const ToastMessageFactory = React.createFactory(ToastMessage.animation);

class Dashboard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentItemClicked: '',
      priviousClickedItem: false,
      addingToCart: '',
      openModal: false,
      itemsarray: this.props.dashboardData.orderItemsList
        ? this.props.dashboardData.orderItemsList
        : [],
      updateCurrentItem: false,
      updatedOrderItemIndex: 0,
      tip: 0.0,
      localLocationChanged: false,
      showOrderTypePopup: false,
      scrollBack: 0,
      editCart: false,
      reOrderItem: '',
      showOutOfStock: false,
      updateCartItem: false,
    };
    this.changeModifiersFromDashboard = this.changeModifiersFromDashboard.bind(
      this
    );
    this.checkBoxOnchangeHandlerFromDashboard = this.changeModifiersFromDashboard.bind(
      this
    );
    this.closeModal = this.closeModal.bind(this);
    this.addItemsToBag = this.addItemsToBag.bind(this);
    this.getItemTaxDetail = this.getItemTaxDetail.bind(this);
    this.addItemToBag = this.addItemToBag.bind(this);
    this.emptyModal = this.emptyModal.bind(this);
    this.resetPreviousClickedItem = this.resetPreviousClickedItem.bind(this);
    this.addPreviousClickedItemToCart = this.addPreviousClickedItemToCart.bind(
      this
    );
  }

  componentWillReceiveProps(nextProps) {
    if (
      !nextProps.dashboardData.showOrderTypePopup &&
      !nextProps.dashboardData.orderTypePopupOnAddToCart &&
      nextProps.dashboardData.tempCartItem !== false &&
      nextProps.dashboardData.tempCartItem.item &&
      nextProps.dashboardData.modeOfOrder
    ) {
      this.addItemToBag(
        nextProps.dashboardData.tempCartItem.item,
        nextProps.dashboardData.tempCartItem.count,
        {},
        nextProps.dashboardData.modeOfOrder
      );
    }
  }

  componentWillMount() {
    this.props.dispatch(updateTipPrice(0, '', 0));
    this.props.dispatch(setPaymentModeDashboard(''));
    const currentRoute = this.props.location.pathname
      .split('/')[1]
      .toLowerCase();
    let previousRoute = this.props.dashboardData.previousRoute;
    previousRoute =
      previousRoute !== false ? previousRoute.toLowerCase() : false;
    const isLocationChange = this.props.dashboardData.locationChanged;
    this.props.dispatch(setRoute(currentRoute));
    if (
      localStorage.getItem('dashboard') &&
      this.props.dashboardData.dataname === localStorage.getItem('dataname')
    ) {
      this.props
        .dispatch(
          addItemToBagCache(JSON.parse(localStorage.getItem('dashboard')))
        )
        .then(orderItems => {
          this.getItemTaxDetail(orderItems);
        });
    } else {
      localStorage.setItem('dataname', this.props.dashboardData.dataname);
    }

    if (
      previousRoute !== false &&
      currentRoute !== previousRoute &&
      !isLocationChange
    ) {
      this.props.dispatch(resetDashboard(false)).then(res => {
        this.props.dispatch(setRoute(currentRoute));
        this.props.dispatch(
          locationChanged({
            changedDataName: null,
            status: false,
            resetUserLocation: true,
          })
        );
      });
    } else {
      this.props.dispatch(setRoute(currentRoute));
      this.props.dispatch(
        locationChanged({ changedDataName: null, status: false })
      );
    }
  }

  closeModal() {
    this.setState({ openModal: false });
  }
  emptyModal() {
    this.setState({ currentItemClicked: '' });
  }

  updateLocationDetails(addressDetails, scrollBack) {
    this.setState({ scrollBack: scrollBack });

    if (addressDetails === undefined) {
      let obj = {
        selectedLocationAddressId: '',
        selectedLocationAddress: '',
      };
      this.props.dispatch(locationDetails(obj));
    } else {
      const {
        id,
        address,
        city,
        state,
        zip,
        dataname,
        lavu_togo_name,
      } = addressDetails;
      const currentDataName = get(this.props.dashboardData, 'dataName', '');
      const currentLavuToGoName = get(this.props.params, 'rname', '');
      const modeOfOrder = get(this.props.dashboardData, 'modeOfOrder', '');
      const refereLavuTogoDataName = get(
        this.props.dashboardData,
        'refereLavuTogoDataName',
        ''
      );

      const selectedAddressDetails = {
        selectedLocationAddressId: id,
        delivery_fees: get(addressDetails, 'delivery_fees', 0),
        deliveryTime: get(addressDetails, 'delivery_time', ''),
        distance: get(addressDetails, 'delivery_distance', ''),
        restuarantName: get(addressDetails, 'title', ''),
        selectedLocationAddress: `${address},${String.fromCharCode(
          13
        )}${city}, ${state} - ${zip}`,
      };

      this.props.dispatch(locationDetails(selectedAddressDetails));

      if (dataname && currentDataName) {
        if (currentDataName.toLowerCase() !== dataname.toLowerCase()) {
          this.props.dispatch(
            locationChanged({
              changedDataName: dataname,
              status: true,
            })
          );

          if (
            lavu_togo_name !== currentLavuToGoName ||
            (refereLavuTogoDataName !== true &&
              refereLavuTogoDataName !== dataname)
          ) {
            this.setState({
              localLocationChanged: {
                changedLavuToGoName: lavu_togo_name,
              },
            });
            if (modeOfOrder === 2) {
              window.location.href = '/' + lavu_togo_name;
            }
          } else {
            this.setState({
              localLocationChanged: {
                changedLavuToGoDataName: dataname,
              },
            });
          }
        } else {
          this.props.dispatch(
            locationChanged({ changedDataName: null, status: false })
          );
          this.setState({
            localLocationChanged: false,
          });
        }
      }
    }
  }

  updateModeOfOrder(mode) {
    this.props.dispatch(modeOfOrder(mode));
  }

  updateOrderPanel(responsejson) {
    this.setState({ showOutOfStock: false });
    this.props.updateOrderPanel(responsejson);
  }

  switchModal(clickedItem) {
    localStorage.setItem('specialInstructions', '');
    let tempObj = JSON.parse(JSON.stringify(clickedItem));
    if (tempObj.forced.length > 0) {
      tempObj.forced = createModifierPath(tempObj.forced, 'forced');
    }

    if (tempObj.optional.length > 0) {
      tempObj.optional = createModifierPath(tempObj.optional, 'optional');
    }

    if (!tempObj['basePrice']) {
      tempObj['basePrice'] = tempObj.price;
    }
    if (!tempObj['baseNutrition']) {
      tempObj['baseNutrition'] = tempObj.nutrition;
    }

    //---------------------------------------------
    //Initialize Pizza Creator modifiers
    //---------------------------------------------
    if (tempObj.use_pizza_creator) initializePizzaCreatorModifiers(tempObj);
    //---------------------------------------------

    window.modalPopped = true;
    this.setState({ currentItemClicked: tempObj, openModal: true });
  }

  updateCartItem(clickedItem, orderItemIndex) {
    this.setState({
      currentItemClicked: JSON.parse(JSON.stringify(clickedItem)),
      openModal: true,
      updateCurrentItem: true,
      updatedOrderItemIndex: orderItemIndex,
      editCart: true,
      showOutOfStock: false,
      updateCartItem: true,
    });
  }

  removeOrderItem(itemIndex) {
    let tempArray = [...this.props.dashboardData.orderItemsList];
    tempArray.splice(itemIndex, 1);
    let totalCartPrice = 0;
    tempArray.forEach(item => {
      totalCartPrice =
        totalCartPrice + parseFloat(parsePrice(item.price, true));
    });
    let DeliveryFee = this.props.dashboardData.locationDetails.delivery_fees
      ? this.props.dashboardData.locationDetails.delivery_fees
      : 0;
    let orderTotal =
      parseFloat(parsePrice(totalCartPrice, true)) +
      parseFloat(parsePrice(DeliveryFee, true));

    this.props
      .dispatch(removeItemFromBag(tempArray, orderTotal))
      .then(orderItems => {
        let languageid = localStorage.getItem('language')
          ? localStorage.getItem('language')
          : '1';
        let orderPanelApiObj = GetCartItems(orderItems);
        let postData = {
          dataname: this.props.dashboardData.dataName,
          cart_contents: JSON.stringify(orderPanelApiObj),
          languageid: languageid,
        };
        let config = {
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + btoa(this.props.jwt),
          },
        };
        let self = this;
        return axios
          .post(ADD_TO_CART + 'tokenId/' + this.props.tokenId, postData, config)
          .then(function(response) {
            self.goToCheckout(response.data.DataResponse);
          });
      });
  }

  removeAllItems() {
    this.props.dispatch(removeItemFromBag([]));
  }

  changeModifiersFromDashboard(changedItem) {
    this.setState({ currentItemClicked: changedItem });
  }

  checkBoxOnchangeHandlerFromDashboard(changedItem) {
    this.setState({ currentItemClicked: changedItem });
  }

  removeCurrentItem() {
    this.setState(
      { currentItemClicked: '', updateCurrentItem: false, editCart: false },
      function afterNull() {}
    );
  }
  editReOrderItem(reOrderItem) {
    this.setState({
      reOrderItem: reOrderItem,
    });
    var reOrderItemData = find(this.props.reOrderItems, function(obj) {
      return obj.id === reOrderItem.id;
    });
    this.switchModal(reOrderItemData);
  }
  backToReOrder() {
    this.setState({ currentItemClicked: this.state.reOrderItem });
  }

  removeCurrentOrderItem() {
    this.props.removeCI();
  }

  hideOrderTypePopup() {
    this.props.dispatch(loading());
    this.props.dispatch(hideOrderTypePopup()).then(() => {
      this.props
        .dispatch(
          loadMenuItems(
            this.props.subMenuItemClicked,
            this.props.dashboardData.modeOfOrder,
            this.state.tokenId,
            this.props.jwt,
            this.props.dashboardData.dataName
          )
        )
        .then(res => {
          this.addPreviousClickedItemToCart();
          this.props.dispatch(loading());
        });
    });
  }

  addPreviousClickedItemToCart() {
    const priviousClickedItem = get(
      this,
      'state.priviousClickedItem.item',
      false
    );

    const { locationChanged, changedDataName } = this.props.dashboardData;

    if (priviousClickedItem && locationChanged) {
      const { tokenId, jwt } = this.props;
      itemExist({
        itemId: priviousClickedItem.id,
        dataname: changedDataName,
        diningType: GetOrderType(this.props.dashboardData.modeOfOrder),
        tokenId: tokenId,
        jwt: jwt,
      }).then(apiResponse => {
        const status = get(apiResponse, 'dataResponse.status', 0);
        if (status === 1) {
          this.addItemToBag(
            this.state.priviousClickedItem.item,
            this.state.priviousClickedItem.count
          );
        } else {
          alertify.set('notifier', 'position', 'top-right');
          alertify.error(
            `${priviousClickedItem.name} ${this.props.intl.formatMessage({
              id: 'notAvailableFor',
              defaultMessage: defaultMsg.notAvailableFor,
            })} ${changedDataName}`
          );
        }
        this.resetPreviousClickedItem();
      });
    } else if (priviousClickedItem) {
      this.addItemToBag(
        this.state.priviousClickedItem.item,
        this.state.priviousClickedItem.count
      );
      this.resetPreviousClickedItem();
    }
  }

  resetPreviousClickedItem() {
    this.setState({
      priviousClickedItem: false,
    });
    this.props.dispatch(unsetOrderTypePopupOnAddToCart());
  }

  isValidItemForBag(item, modeOfOrder = false) {
    const { addToCart } = this.refs;

    const {
      intl: { formatMessage },
      dashboardData,
    } = this.props;
    if (!item) {
      addToCart.error(
        formatMessage({
          id: 'itemInfoNotFound',
          defaultMessage: defaultMsg.itemInfoNotFound,
        })
      );
      return false;
    } else if (!item.dining_option) {
      addToCart.error(
        formatMessage({
          id: 'itemDiningOptionError',
          defaultMessage: defaultMsg.itemDiningOptionError,
        })
      );
      return false;
    } else if (
      item.dining_option
        .toLowerCase()
        .indexOf(
          GetOrderType(modeOfOrder || dashboardData.modeOfOrder).toLowerCase()
        ) === -1
    ) {
      addToCart.error(
        formatMessage({
          id: 'itemOrderTypeError',
          defaultMessage: defaultMsg.itemOrderTypeError,
        })
      );
      return false;
    } else {
      return true;
    }
  }
  getItemTaxDetail(orderItems) {
    let languageid = localStorage.getItem('language')
      ? localStorage.getItem('language')
      : '1';
    let orderPanelApiObj = GetCartItems(orderItems);

    let postData = {
      dataname: this.props.dashboardData.dataName,
      cart_contents: JSON.stringify(orderPanelApiObj),
      languageid: languageid,
    };
    let config = {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + btoa(this.props.jwt),
      },
    };
    return axios
      .post(ADD_TO_CART + 'tokenId/' + this.props.tokenId, postData, config)
      .then(
        function(response) {
          this.goToCheckout(response.data.DataResponse);
        }.bind(this)
      );
  }
  addItemToBag(item, itemCount, cartObj, modeOfOrder) {
    const { updateCartItem } = this.state;
    this.setState({ addingToCart: true });
    if (this.isValidItemForBag(item, modeOfOrder)) {
      let tempArray = [...this.props.dashboardData.orderItemsList];

      if (!this.state.updateCurrentItem && this.refs.addToCart) {
        if (itemCount > 1) {
          for (var i = 0; i < itemCount; i++) {
            tempArray.push(item);
          }
        } else {
          tempArray.push(item);
        }
      } else {
        if (itemCount > 1) {
          tempArray[this.state.updatedOrderItemIndex] = item;
          for (let i = 0; i < itemCount - 1; i++) {
            tempArray.push(item);
          }
        } else {
          tempArray[this.state.updatedOrderItemIndex] = item;
        }
      }
      this.setState({ updateCurrentItem: false });
      let totalCartPrice = 0;

      tempArray.forEach(item => {
        totalCartPrice =
          totalCartPrice + parseFloat(parsePrice(item.price, true));
      });

      const DeliveryFee = get(
        this,
        'props.dashboardData.locationDetails.delivery_fees',
        0
      );
      const orderTotal =
        parseFloat(parsePrice(totalCartPrice, true)) +
        parseFloat(parsePrice(DeliveryFee, true));
      checkCartItemsAvailable(cartObj, this.props)
        .then(cartStockDetails => {
          return cartStockDetails;
        })
        .then(stockDetails => {
          if (stockDetails !== false) {
            this.setState({
              showOutOfStock: true,
              showOutOfStockDetails: stockDetails,
              currentItemClicked: '',
              addingToCart: false,
            });
          } else {
            this.props
              .dispatch(
                addItemToBag(
                  tempArray,
                  orderTotal,
                  itemCount,
                  this.state.updateCartItem
                )
              )
              .then(orderItems => {
                this.setState({ updateCartItem: false });
                this.getItemTaxDetail(orderItems);
              });
            if (this.refs.addToCart) {
              this.refs.addToCart.success(
                this.props.intl.formatMessage({
                  id: updateCartItem ? 'itemUpdatedInCart' : 'itemAddedToCart',
                  defaultMessage: updateCartItem
                    ? defaultMsg.itemUpdatedInCart
                    : defaultMsg.itemAddedToCart,
                })
              );
            }
            window.modalPopped = -1;
            this.setState({
              currentItemClicked: '',
              addingToCart: false,
              showOutOfStock: false,
            });
          }
        });
    }
  }

  goToCheckout(goToCheckoutResp) {
    this.props.dispatch(goToCheckout(goToCheckoutResp));
  }

  addItemsToBag(items) {
    this.setState({
      itemsarray: items,
    });
  }

  signInModal(signInCaller) {
    this.props.dispatch(openSignInPopUp(signInCaller));
  }

  deliveryAddress(addressDetails) {
    if (addressDetails === undefined) {
      let obj = {
        deliveryAddress: '',
      };
      this.props.dispatch(deliveryDetails(obj));
    } else {
      let obj = {
        deliveryAddress: addressDetails,
      };
      this.props.dispatch(deliveryDetails(obj));
    }
  }

  selectedDate(date, starttime, endtime) {
    this.props.dispatch(orderDate(date));
  }

  selectedTime(time) {
    this.props.dispatch(orderTime(time));
  }

  showOrderTypePopup() {
    return (
      (this.props.dashboardData.showOrderTypePopup ||
        this.state.showOrderTypePopup) &&
      this.props.tokenId &&
      this.props.dashboardData.refereLavuTogoDataName !== true
    );
  }
  onClose() {
    this.setState({ showOutOfStock: false });
  }

  render() {
    return (
      <div>
        <div className="fullContent">
          <ToastContainer
            toastMessageFactory={ToastMessageFactory}
            ref="addToCart"
            className="toast-top-right"
          />

          <AddItemPopup
            changeModifiersFromDashboard={changedItem => {
              this.changeModifiersFromDashboard(changedItem);
            }}
            currentItem={this.state.currentItemClicked}
            addingToCart={this.state.addingToCart}
            editCart={this.state.editCart}
            removeCI={() => this.removeCurrentItem()}
            backToReOrder={() => this.backToReOrder()}
            editReOrder={reOrderItem => this.editReOrderItem(reOrderItem)}
            updateOrderPanel={jsonresponse =>
              this.updateOrderPanel(jsonresponse)
            }
            orderId={this.props.orderId}
            itemsInBag={this.props.itemsInBag}
            turnOnSpinner={(msg, type) => this.props.turnOnSpinner(msg, type)}
            openModal={this.state.openModal}
            closeModal={this.closeModal}
            itemsarray={this.state.itemsarray}
            addItemToBag={(item, itemCount, cartObj) => {
              this.addItemToBag(item, itemCount, cartObj);
            }}
            orderTypePopupOnAddToCart={
              this.props.dashboardData.orderTypePopupOnAddToCart
            }
            updateAddingToBag={() => {
              this.updateAddingToBag();
            }}
            addItemsToBag={items => {
              this.addItemsToBag(items);
            }}
            updateCurrentItem={this.state.updateCurrentItem}
            updateCartItem={this.state.updateCartItem}
          />
          <Items
            items={this.props.dispItems}
            switchModal={clickedItem => this.switchModal(clickedItem)}
            dashboardData={this.props.dashboardData}
            openModal={this.state.openModal}
            closeModal={this.closeModal}
          />

          {this.state.showOutOfStock ? (
            <OutOfStockItems
              outOfStockItems={this.state.showOutOfStockDetails}
              cartItems={true}
              show={true}
              onClose={() => {
                this.onClose();
              }}
            />
          ) : null}
          <div style={{ clear: 'both' }} />
        </div>
        <OrderPanel
          orderPanelClass="sideBar hidden-md-down"
          selectedLocationAddress={
            this.props.dashboardData.locationDetails.selectedLocationAddress
          }
          selectedLocationAddressId={
            this.props.dashboardData.locationDetails.selectedLocationAddressId
          }
          modeOfOrder={this.props.dashboardData.modeOfOrder}
          orderItems={this.props.dashboardData.orderItemsList}
          signInModal={signInCaller => this.signInModal(signInCaller)}
          switchModal={clickedItem => this.switchModal(clickedItem)}
          updateCartItem={(clickedItem, orderItemIndex) => {
            this.updateCartItem(clickedItem, orderItemIndex);
          }}
          removeOrderItem={itemIndex => this.removeOrderItem(itemIndex)}
          removeAllItems={() => this.removeAllItems()}
          goToCheckout={response => this.goToCheckout(response)}
          cartPrice={this.props.dashboardData.cartPrice}
          deliveryAddress={
            this.props.dashboardData.locationDetails.selectedLocationAddress
          }
          orderPanelFromDashboard="true"
          deliveryTime={this.props.dashboardData.locationDetails.deliveryTime}
          DeliveryFee={
            this.props.dashboardData.locationDetails.delivery_fees
              ? this.props.dashboardData.locationDetails.delivery_fees
              : 0
          }
          rname={this.props.params.rname}
          tip={this.state.tip}
        />
      </div>
    );
  }
}

// Retrieve data from store as props
function mapStateToProps(state) {
  return {
    dashboardData: dashboardData(state),
    isDataNameFilterForDining: isDataNameFilterForDining(state),
    tokenId: state.auth.tokenId,
    jwt: state.auth.jwt,
    checkoutData: checkoutData(state),
    subMenuItemClicked: state.menuCategories.subMenuItemClicked,
    menuItems: state.menuCategories.menuItems,
    reOrderItems: state.dashboard.reOrderItemsData,
  };
}

Dashboard.propTypes = {
  intl: intlShape.isRequired,
};

export default connect(mapStateToProps)(injectIntl(Dashboard));



// WEBPACK FOOTER //
// ./src/views/dashboard/Dashboard.jsx